<template>
  <div class="container_dash">
    <div class="row content_date justify-content-center">
      <div class="info col-12 col-md-12 col-lg-12">
        <strong>Consultar ingreso de códigos</strong>
      </div>
      <div class="col-12 col-md-3 col-lg-3">
        <input
          v-model="form.initialDate"
          type="text"
          class="form-control"
          placeholder="Fecha inicial *"
          onfocus="(this.type='date')"
          min="2020-01-01"
        >
      </div>
      <div class="col-12 col-md-3 col-lg-3">
        <input
          v-model="form.finallyDate"
          type="text"
          class="form-control"
          id="finallyDate"
          placeholder="Fecha final *"
          onfocus="(this.type='date')"
          :min="form.initialDate"
          :max="maxDateFinally()"
          disabled
        >
      </div>
      <div class="col-4">
        <div class="form-group">
          <select
            class="form-control"
            name="typeUser"
            id="typeUser"
            v-model="form.typeUser"
          >
            <option value="null" disabled selected>Tipo de usuario *</option>
            <option value="1">Motero</option>
            <option value="2">Lubricador</option>
            <option value="3">Motero y Lubricador</option>
          </select>
        </div>
      </div>

      <div class="col-12 col-md-1 col-lg-1 btn_search">
        <button
          class="btn btn-danger btn-sm"
          @click="getReport()"
        >
          <div v-if="utils.searching" style="display:flex;">
            <span>
              Consultando...&nbsp;
            </span>
            <div class="loader"></div>
          </div>
          <span v-else class="fas fa-search"></span>
        </button>
      </div>
    </div>

    <div v-if="utils.result" class="cont_graphs_and_tables">

      <div class="row row_table">
        <div v-if="user == 1 || user == 3" class="col-12 col-md-12 col-lg-12">
          <div class="row justify-content-initial">
            <span class="cant_users">Total de códigos inscritos: <strong style="color:#595959;">{{ parseFloat(totalCodesBik).toLocaleString() }}</strong></span>
          </div>

          <h2 class="title_sec_1">
            Moteros que inscribieron códigos
          </h2>
          <div class="codes_general">
            <table class="table">
              <caption class="visually-hidden">Listado de Códigos</caption>
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Fecha inscripción</th>
                  <th scope="col">Nombre de usuario</th>
                  <th scope="col">Número de documento</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Email</th>
                  <th scope="col">Departamento</th>
                  <th scope="col">Ciudad</th>
                  <th scope="col">Cantidad de códigos</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in codesBik" :key="item.id">
                  <td>{{ item.user_redeem_date }}</td>
                  <td v-if="item.name != null && item.last_name != null">{{ item.name + ' ' + item.last_name }}</td>
                  <td v-else>{{ item.name }}</td>
                  <td>{{ item.document_number }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.state_name }}</td>
                  <td>{{ item.city_name }}</td>
                  <td>{{ item.cantCodes }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="7"></td>
                  <td><strong class="totalTable">Total de códigos:</strong> {{ parseFloat(totalCodesBik).toLocaleString() }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <button
            class="btn btn-success btn_download"
            @click="downloadReports(1)"
          >
            <strong>Descargar</strong>&nbsp;<span class="fas fa-download"></span>
          </button>
        </div>

        <div v-if="user == 2 || user == 3" class="col-12 col-md-12 col-lg-12 content_table">
          <div class="row justify-content-initial">
            <span class="cant_users">Total de códigos inscritos: <strong style="color:#595959;">{{ parseFloat(totalCodesLub).toLocaleString() }}</strong></span>
          </div>

          <h2 class="title_sec_1">
            Lubricadores que inscribieron códigos
          </h2>
          <div class="codes_general">
            <table class="table">
              <caption class="visually-hidden">Listado de Códigos</caption>
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Fecha inscripción</th>
                  <th scope="col">Nombre de usuario</th>
                  <th scope="col">Número de documento</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Email</th>
                  <th scope="col">Departamento</th>
                  <th scope="col">Ciudad</th>
                  <th scope="col">Cantidad de códigos</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in codesLub" :key="item.id">
                  <td>{{ item.lubricator_redeem_date }}</td>
                  <td v-if="item.name != null && item.last_name != null">{{ item.name + ' ' + item.last_name }}</td>
                  <td v-else>{{ item.name }}</td>
                  <td>{{ item.document_number }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.state_name }}</td>
                  <td>{{ item.city_name }}</td>
                  <td>{{ item.cantCodes }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="7"></td>
                  <td><strong class="totalTable">Total de códigos:</strong> {{ parseFloat(totalCodesLub).toLocaleString() }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <button
            class="btn btn-success btn_download"
            @click="downloadReports(2)"
          >
            <strong>Descargar</strong>&nbsp;<span class="fas fa-download"></span>
          </button>
        </div>

      </div>
      <!-- <div v-else class="row justify-content-center">
        <span class="without">
          No hay códigos inscritos para las fechas ingresadas
        </span>
      </div> -->

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import * as XLSX from 'xlsx';

export default {
  name: "registeredCodes",

  data() {
    return {
      utils: {
        searching: false,
        result: false,
      },
      form:{
        initialDate: null,
        finallyDate: null,
        typeUser: null
      },
      user: 0,
      codesBik: [],
      codesLub: [],
      totalCodesBik: 0,
      totalCodesLub: 0
    };
  },
  methods: {
    maxDateFinally(){
      if (this.form.initialDate) {
        const maxDate = new Date(this.form.initialDate);
        maxDate.setMonth(maxDate.getMonth() + 1);
        return maxDate.toISOString().split('T')[0];
      } else {
        const now = new Date();
        // now.setFullYear(now.getFullYear() - 18);
        return now.toISOString().substr(0, 10);
      }
    },
    checkForm(){
      if(this.form.initialDate == null){
        this.$swal({
          icon: "info",
          title: "Lo sentimos",
          text: "Para continuar debe ingresar una fecha inicial",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }
      if(this.form.finallyDate == null){
        this.$swal({
          icon: "info",
          title: "Lo sentimos",
          text: "Para continuar debe ingresar una fecha final",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }
      if(this.form.typeUser == null){
        this.$swal({
          icon: "info",
          title: "Lo sentimos",
          text: "Para continuar debe ingresar el tipo de usuario",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }
      if(this.form.initialDate && this.form.finallyDate && this.form.typeUser){
        return true;
      }
    },
    getReport(){
      if(this.checkForm()){
        this.utils.searching = true;
        this.user = 0;
        this.codesBik = [];
        this.codesLub = [];
        this.totalCodesBik = 0;
        this.totalCodesLub = 0;
        axios
        .post('admin/get-registered-codes/', this.form)
        .then(response => {
          if(response.data.cod == 0){
            this.user = response.data.data.typeUser;

            if(this.user == 1){
              this.codesBik = response.data.data.totalCodes;
              this.codesBik.sort((a, b) => new Date(a.user_redeem_date) - new Date(b.user_redeem_date));
              this.codesBik.forEach(element => {
                this.totalCodesBik += element.cantCodes;
              });
            }
            else if(this.user == 2){
              this.codesLub = response.data.data.totalCodes;
              this.codesLub.sort((a, b) => new Date(a.lubricator_redeem_date) - new Date(b.lubricator_redeem_date));
              this.codesLub.forEach(element => {
                this.totalCodesLub += element.cantCodes;
              });
            } else {
              this.codesBik = response.data.data.totalCodesBik;
              this.codesBik.sort((a, b) => new Date(a.user_redeem_date) - new Date(b.user_redeem_date));
              this.codesBik.forEach(element => {
                this.totalCodesBik += element.cantCodes;
              });

              this.codesLub = response.data.data.totalCodesLub;
              this.codesLub.sort((a, b) => new Date(a.lubricator_redeem_date) - new Date(b.lubricator_redeem_date));
              this.codesLub.forEach(element => {
                this.totalCodesLub += element.cantCodes;
              });
            }
            
            this.utils.searching = false;
            this.utils.result = true;
          } else {
            this.$swal({
              icon: "warning",
              title: "Lo sentimos",
              text: response.data.message,
              confirmButtonColor: "#dc3545"
            });
            this.utils.searching = false;
            this.utils.result = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.utils.searching = false;
          this.utils.result = false;
        });
      }
    },
    downloadReports(type){
      this.$swal({
        icon: "question",
        title: "Descargar",
        text: "¿Quieres descargar el reporte?",
        confirmButtonText: "Sí, descargar",
        confirmButtonColor: "#28a745",
        showCancelButton: true,
        cancelButtonText: "No",
        cancelButtonColor: "#dc3545"
      }).then(res => {
        if(res.isConfirmed){
          if(type == 1){
            const reportDownload = [];
            this.codesBik.forEach((item) => {
              let completeName;
              item.last_name != null ? completeName = item.name + ' ' + item.last_name : completeName = item.name;
              reportDownload.push({
                Fecha: item.user_redeem_date,
                Nombre_Completo: completeName,
                Cédula: item.document_number,
                Celular: item.phone,
                Email: item.email,
                Departamento: item.state_name,
                Ciudad: item.city_name,
                Cantidad_De_Códigos: item.cantCodes
              });
            });
            const data = XLSX.utils.json_to_sheet(reportDownload);
            // Ancho de columnas
            const totalColumns = XLSX.utils.decode_range(data['!ref']).e.c + 1;
            data['!cols'] = Array(totalColumns).fill({ wch: 30 });
            // Atura de filas
            const totalRows = XLSX.utils.decode_range(data['!ref']).e.r + 1;
            data['!rows'] = Array(totalRows).fill({ hpx: 25 });
            
            const workbook = XLSX.utils.book_new();
            const idate = this.form.initialDate;
            const fdate = this.form.finallyDate;
            const filename = `${idate}-hasta-${fdate}`;
            XLSX.utils.book_append_sheet(workbook, data, filename);
            XLSX.writeFile(workbook, `${filename}.xlsx`);
          } else {
            const reportDownload = [];
            this.codesLub.forEach((item) => {
              let completeName;
              item.last_name != null ? completeName = item.name + ' ' + item.last_name : completeName = item.name;
              reportDownload.push({
                Fecha: item.lubricator_redeem_date,
                Nombre_Completo: completeName,
                Cédula: item.document_number,
                Celular: item.phone,
                Email: item.email,
                Departamento: item.state_name,
                Ciudad: item.city_name,
                Cantidad_De_Códigos: item.cantCodes
              });
            });
            const data = XLSX.utils.json_to_sheet(reportDownload);
            // Ancho de columnas
            const totalColumns = XLSX.utils.decode_range(data['!ref']).e.c + 1;
            data['!cols'] = Array(totalColumns).fill({ wch: 30 });
            // Atura de filas
            const totalRows = XLSX.utils.decode_range(data['!ref']).e.r + 1;
            data['!rows'] = Array(totalRows).fill({ hpx: 25 });
            
            const workbook = XLSX.utils.book_new();
            const idate = this.form.initialDate;
            const fdate = this.form.finallyDate;
            const filename = `${idate}-hasta-${fdate}`;
            XLSX.utils.book_append_sheet(workbook, data, filename);
            XLSX.writeFile(workbook, `${filename}.xlsx`);
          }
        }
      });
    },
  },
  watch: {
    "form.initialDate": function(n) {
      if (n != null && n != "") {
        $('#finallyDate').attr("disabled", false);
        this.form.finallyDate = null;
      } else {
        $('#finallyDate').attr("disabled", true);
        this.form.finallyDate = null;
      }
    },
    "form.finallyDate": function(n) {
      if(n != null && n != ""){
        if(this.form.initialDate > n){
          this.$swal({
            icon: "info",
            title: "Lo sentimos",
            text: "La fecha final no puede ser menor que la fecha inicial",
            confirmButtonColor: "#dc3545"
          });
          this.form.finallyDate = null;
          return false;
        } else {
          return true;
        }
      }
    },
  },
  // mounted(){
  //   console.log('mounted');
  // }
};
</script>

<style scoped>
.container_dash{
  padding: 4% 0%;
  background-color: #eaeaea;
}
.info{
  background-color: #dc3545;
  padding: 20px;
  border-radius: 10px;
}
.info > strong{
  text-align: center;
  font-size: 16px;
  color:#fff;
  font-family: "GothamBookItalic", sans-serif;
}
.content_date{
  background: linear-gradient(
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.2)
  ), url('../../../../assets/img/background_registered_codes.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 400px;
  padding: 10%;
}
/* .btn_search{
  display: flex;
} */
.btn_search > button{
  padding: 8px 20px;
}
.title_sec_1{
  text-align: center;
  font-size: 20px;
  color:#dc3545;
  font-family: "GothamBoldItalic", sans-serif;
}
.cont_graphs_and_tables{
  padding: 4% 0%;
}
.cant_users{
  text-align: initial;
  font-size: 18px;
  color:#dc3545;
  font-family: "GothamBoldItalic", sans-serif;
  padding: 5px 12px;
}
.totalTable{
  color:#dc3545;
}
.without{
  text-align: center;
  font-size: 20px;
  color:#dc3545;
  font-family: "GothamBoldItalic", sans-serif;
  padding: 5px;
}
.chart-container {
  height: 90vh;
  width: 100%;
  margin: 20px 0px;
}
.chart {
  height: 90vh;
  width: 100%;
}
.codes_general{
  overflow-y: auto;
  height: 500px;
}
.thead-dark{
  position: sticky;
  top: 0;
}
tfoot {
  position: sticky;
  bottom: 0;
  background-color: #eaeaea;
}
.btn_download{
  padding: 8px 40px;
  margin: 10px 0px;
  color: white !important;
}
.row_table{
  padding: 30px 0px;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 20px;
  --b: 5px; 
  /* aspect-ratio: 1; */
  border-radius: 50%;
  padding: 1px;
  background: conic-gradient(#0000 10%,#fff) content-box;
  -webkit-mask:
  repeating-conic-gradient(#0000 0deg,#000 1deg 20deg,#0000 21deg 36deg),
  radial-gradient(farthest-side,#0000 calc(100% - var(--b) - 1px),#000 calc(100% - var(--b)));
  mask-composite: intersect;
  animation: l4 1s infinite steps(10);
}
@keyframes l4 {to{transform: rotate(1turn)}}

.content_table{
  padding-top: 50px;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* MOBILE */
@media (max-width: 768px) {
  .container_dash{
    padding: 18% 0%;
  }
  .info > strong{
    font-size: 14px;
  }
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("../../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("../../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("../../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>